// extracted by mini-css-extract-plugin
export var containerDesktop = "styles-module--containerDesktop--37mPJ";
export var left = "styles-module--left--1p9Iy";
export var logo = "styles-module--logo--1WmDb";
export var right = "styles-module--right--1Nr6G";